import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  Grid,
  ProgressBar,
  Row
} from 'react-bootstrap';
import languagesPropType from './languagesPropType.js';
import styles from './PasswordStrengthMeter.css';
import translate from './translate.js';

const PasswordStrengthMeter = ({
  language,
  rulesResults,
  strengthScore
}) => (
  <div className="hx">
    <Grid fluid={true}>
      <div className={styles.passwordStrengthMeter}>
        <div className={styles.header}>{translate('passwordStrength', language)}</div>
        <Row>
          <Col xs={12}>
            { drawMeterSegment('Weak', strengthScore === 1, strengthScore >= 1, language, strengthScore <= 1 ? "danger" : "success") }
            { drawMeterSegment('Good', strengthScore === 2, strengthScore >= 2, language) }
            { drawMeterSegment('Strong', strengthScore === 3, strengthScore >= 3, language) }
          </Col>
        </Row>
        <Row style={{marginTop: '20px'}}>
          <Col xs={12}>
            <div className={styles.requirementsHeader}>{translate('requirements', language)} <span style={{fontWeight: 'bolder'}}>({translate('tip', language)})</span>
            </div>
            <div id="requirements" className={styles.requirements}>
              { drawRequirements(rulesResults, language) }
            </div>
          </Col>
        </Row>
      </div>
    </Grid>
  </div>
);
0;
function drawMeterSegment(caption, active, full, language, bsStyle = "success") {
  return (
    <Col xs={4} style={{paddingLeft: '0px', paddingRight: '5px'}}>
      <ProgressBar srOnly active={active} bsStyle={bsStyle} now={full ? 100 : 0} style={{marginBottom: '0', height: '14px'}} />
      <div className={styles.meterLabel}>{translate(caption, language)}</div>
    </Col>
  );
}

function drawRequirements(results, language) {
  return results.map(result => (
    <div key={result.name} className={styles.requirementLabel}>
      <div className={result.pass ? styles.requirementSatisfied : styles.requirementUnsatisfied}>
        <i className={`${result.pass ? styles.requirementSatisfiedIcon : styles.requirementUnsatisfiedIcon} ${styles.requirementIcon} fa fa-check-circle`} /><span className={styles.requirementBaseLabel}>{translate(result.name, language)}</span>
      </div>
      {drawSubtestResults(result.subtests, language)}
    </div>
  ));
}

function drawSubtestResults(subtests, language) {
  if (!subtests) return null;

  return subtests.map(subtest => (
    <div key={subtest.name} className={`${subtest.pass ? styles.requirementSatisfied : styles.requirementUnsatisfied} ${styles.subtestRequirementLabel}`}>{translate(subtest.name, language)}</div>
  ));
}

PasswordStrengthMeter.defaultProps = {
  language: languagesPropType.defaultProp,
};

PasswordStrengthMeter.propTypes = {
  language: languagesPropType.propType,
  rulesResults: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    pass: PropTypes.bool.isRequired,
    subtests: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      pass: PropTypes.bool.isRequired,
    })),
  })).isRequired,
  strengthScore: PropTypes.number.isRequired,
};

export default PasswordStrengthMeter;